module.exports = __webpack_public_path__ + "static/media/frames-palette.aad73b89.png";